<template>
  <div class="live-container">
    <!--页面动效部分-->
    <div class="bg-con">
      <!--开屏动效-->
      <div v-show="hasOpenAnimate" class="open-con">
        <img class="open-bg" src="../../assets/images/open-bg.png" alt="壹心理直播">
        <!--针对长屏机型兼容白色底色-->
        <div class="write-bg"></div>
      </div>

      <!--紫色背景猫猫滚动动效-->
      <img class="dola-bg" src="../../assets/images/dola-bg.png" alt="壹心理直播">

      <img class="gif-1-1" style="opacity:1" src="../../assets/images/cat04.gif" alt="壹心理直播">
      <img class="gif-1-2" style="opacity:0" src="../../assets/images/cat05.gif" alt="壹心理直播">
      <img class="gif-1-3" style="opacity:0" src="../../assets/images/cat03.gif" alt="壹心理直播">
      <img class="gif-1-4" style="opacity:0" src="../../assets/images/cat01.gif" alt="壹心理直播">

      <img class="gif-2" src="../../assets/images/cat02.gif" alt="壹心理直播">
      <img class="gif-3" src="../../assets/images/cat03.gif" alt="壹心理直播">
      <img class="gif-4" src="../../assets/images/cat04.gif" alt="壹心理直播">
      <img class="gif-5" src="../../assets/images/cat05.gif" alt="壹心理直播">
      <img class="gif-6" src="../../assets/images/cat06.gif" alt="壹心理直播">
      <img class="gif-7" src="../../assets/images/play.gif" alt="壹心理直播">
      <img class="gif-8" src="../../assets/images/play.gif" alt="壹心理直播">

      <img class="clouds-1" src="../../assets/images/clouds1.png" alt="壹心理直播">
    </div>

    <!--列表主体内容-->
    <div ref="scrollCon" class="scroll-con" v-if="!noData">
      <!-- 广告位 -->
      <div v-if="showActivity" class="living-item-container isBilling" @click="handleBilling">
        <living :item="advertising" :isBilling="true"></living>
      </div>

      <!-- 合集、直播、预告、回放 -->
      <div class="preview-list-con">
        <div v-for="item in livingList" :key="item.id" class="live-item-container" @click="goToLive('living', item)">
          <living :item="item"></living>
        </div>
        <div v-for="item in previewList" :key="item.id" class="live-item-container" @click="goToLive('live', item)">
          <live :item="item"></live>
        </div>
         <div v-for="item in collectionList" :key="'collection' + item.id" class="live-item-container" @click="goToLive('collection', item)">
          <collection :item="item"></collection>
        </div>
        <div v-for="item in replayList" :key="item.id" class="live-item-container" @click="goToLive('replay', item)">
          <replay-item :item="item"></replay-item>
        </div>
      </div>
      <div v-if="replayList.length > 0" class="load-state">
        <div class="finish" v-if="finish">
          <span>没有更多了~</span>
        </div>
        <div class="more" v-else-if="!finish && loading">
          <span>加载中</span>
        </div>
      </div>
    </div>
    <div ref="scrollCon" class="no-list" v-else>
      <img src="../../assets/images/no-comment.png" alt="壹心理直播">
      <p>当前暂无直播</p>
    </div>
  </div>
</template>

<script>
  import  { getLiveList } from '@/api/live'
  import { pagination, bridge } from '@/mixins'
  import living from './living'
  import live from './live'
  import collection from './collection'
  import { getToken } from '@/utils/utils'
  import { getPlatform } from 'lib/tools/getPlatform'
  import Bridge from 'lib/lib/Bridge'
  import { setStorage, getStorage } from '@/utils/storage'
  import { versionfunegt } from 'lib/tools/utils'
  import ReplayItem from '../replayList/replayItem'
  import { getReplayList } from 'api/live'

  export default {
    name: "LiveList",
    components: {
      living,
      live,
      collection,
      ReplayItem,
    },
    mixins: [pagination, bridge],
    data() {
      return {
        token: '',
        isYixinliApp: false,
        livingList: [],
        previewList: [],
        collectionList: [],
        replayList:[],
        advertising: {}, /*广告位*/
        loading: false,
        finish: false,
        showState: false,
        h5Appear: false,
        isTouch: false,
        hasOpenAnimate: false, // 开屏动画
        lastLoadPage: 1,
        hideAnimateDom: true // 执行完动画后隐藏元素
      }
    },
    computed: {
      showActivity() {
        return this.advertising && (this.advertising.liveId || this.advertising.activityTitle || this.advertising.activityUrl)
      },
      noData() {
        /*无直播，预告，回放，广告的情况*/
        return this.livingList.length === 0 && this.previewList.length === 0 && this.replayList.length === 0 && this.showActivity
      }
    },
    mounted() {
      this.token = getToken()
      this.isYixinliApp = getPlatform().isYixinliApp

      if (this.isYixinliApp) {
        this.handleAppActive()
      }
      this.handleScrollAnimate()

      if (this.isYixinliApp && !versionfunegt(window.$platform.yixinliAPPVersion, '6.10.6')) {
        this.filterSpecial = true
      }
      this.init()
      /*监听触摸状态，触摸时动效停止滚动*/
      window.addEventListener('touchstart', () => {
        this.isTouch = true
      })
      window.addEventListener('touchend', () => {
        this.isTouch = false
      })

      /*开屏背景部分拼接，难免会出现img和div加载快慢出现拼接闪动效果，这里先加一层白色背景后变透明减少闪动体验*/
      const enterPageTimeout = setTimeout(() => {
        let openCon = document.querySelector('.open-con')
        openCon.style.background = 'transparent'
        clearTimeout(enterPageTimeout)
      }, 100)
    },
    methods: {
      init(pageSize) {
        this.fetchData()
        this.fetchReplayData(pageSize)
        this.$nextTick(() => {
          window.addEventListener('scroll', () => {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
            let scrollHeight = document.body.scrollHeight
            let clientHeight = document.documentElement.clientHeight
            if (scrollHeight - scrollTop - clientHeight < 50 && !this.loading && !this.finish) {
              this.fetchReplayData()
            }
          })
        })
        this.$stat.send({
          name: `直播-页面访问`,
          properties: {
            页面: '直播列表页',
          }
        })
      },
      fetchData() {
        getLiveList({
          pageNo: this.pageNo,
          pageSize: 100
        }).then(({ code, data }) => {
          if (+code === 0) {
            let advanceList = data.advanceList.list
            this.previewList = advanceList.filter(item => !(this.filterSpecial && item.isSelected) && item.liveTime && item.nowDateTime && new Date(item.liveTime.replace(/-/g, '/')).getTime() > new Date(item.nowDateTime.replace(/-/g, '/')).getTime())
            this.livingList = data.liveList.filter(item => !(this.filterSpecial && item.isSelected))
            if (!(this.filterSpecial && data.liveIndex.isSelected)) {
              this.advertising = data.liveIndex
            }
            if (!this.filterSpecial) {
              this.collectionList = data.collectionList
            }
          }
        })
      },
      fetchReplayData(pageSize) {
        if (this.loading) return false
        this.loading = true
        getReplayList({
          pageNo: this.pageNo,
          pageSize: pageSize || this.pageSize
        }).then(({code, data}) => {
          if (+code === 0) {
            /*为了优化app端返回时的闪动，首先记录加载的页数(按pageSize=10计算)，在页面active时一次性更新已加载过的数据*/
            this.lastLoadPage = this.pageNo
            if (pageSize) {
              this.lastLoadPage = parseInt(pageSize / this.pageSize)
            }

            /*开始处理数据*/
            if (this.h5Appear) { // 从详情页返回列表页重新请求数据，为了防止闪动，拿到数据后直接替换
              this.replayList = data.list.filter(item => !(this.filterSpecial && item.isSelected))
              this.h5Appear = false
            } else { // 上滑加载更多直接拼接数据
              this.replayList = this.replayList.concat(data.list.filter(item => !(this.filterSpecial && item.isSelected)))
            }

            this.totalCount = data.totalCount
            this.totalPage = data.totalPage
            this.pageNo++

            // 关闭正在加载中
            this.loading = false

            // 如果没有更多数据，则加载完成
            if (this.pageNo > data.totalPage) {
              this.finish = true
              return
            }

            this.$nextTick(() => {
              if (this.$refs.scrollCon && this.$refs.scrollCon.clientHeight <= document.documentElement.clientHeight) {
                this.fetchReplayData()
              }
            })
          }
        })
      },
      /*页面跳转*/
      handleBilling() {
        const advertising = this.advertising
        /*是否直播*/
        if (advertising.liveId) {
          /*是否课程*/
          // 0-未开始 1-进行中 2-已结束 3 暂停
          let type = ''
          switch (advertising.liveStatus) {
            case 0:
              type = 'live'
              break;
            case 1:
            case 3:
            case 2:
              type = 'living'
              break;
          }
          this.goToLiveDetail(type, advertising.liveId, advertising.lessonId)
        } else {
          /*跳转活动地址*/
          if (!advertising.activityUrl) return
          if (window.isYixinliApp) {
            this.openWebView({
              url: advertising.activityUrl
            })
          } else {
            window.location.href = advertising.activityUrl
          }
        }
      },
      goToCourse(id) {
        /*跳转课程*/
        let href = ''
        if (window.isYixinliApp) {
          href = `yixinli://open_lesson_detail?id=${id}`
        } else {
          href = `${window.$liveApi['m-xy_url']}/lesson/${id}`
        }
        window.location.href = href
      },
      handleStat(type, item) { // 处理埋点
        if (type === 'replay' || type === 'collection') {
          this.$stat.send({
            name: '直播-交互行为',
            properties: {
              业务: '直播',
              行为: '点击',
              对象: '回放点击',
              页面: '回放列表页',
              页面title: item.title
            }
          })
        } else {
          this.$stat.send({
            name: '直播-交互行为',
            properties: {
              业务: '直播',
              行为: '点击',
              对象: type === 'living' ? '直播点击' : '预告点击',
              被点击的直播id: item.id,
              页面: '直播列表页',
              页面title: item.liveTitle
            }
          })
        }
      },
      goToLive(type, item) {
        this.handleStat(type, item)
        let collectionId = '',
            id = item.id
        if (type === 'collection') {
          id = item.recordedId
          collectionId = item.id
        }
        this.goToLiveDetail(type, id, item.lessonId, collectionId)
      },
      goToLiveDetail(type, liveId, courseId, collectionId) {
        let appUrl = ''
        let h5Router = ''

        switch (type) {
          case 'living':
            appUrl = `yixinli://open_live_play?live_id=${liveId}`
            h5Router = '/liveDetails'
            break;
          case 'live':
            appUrl = `yixinli://open_live_notice?live_id=${liveId}`
            h5Router = '/previewDetails'
            break;
          case 'replay':
          case 'collection':
            appUrl = `yixinli://open_live_replay?replay_id=${liveId}&collection_id=${collectionId}`
            h5Router = '/previewDetails'
            break;
        }

        if (courseId) {
          /*付费课程*/
          this.goToCourse(courseId)
        } else {
          if (this.isYixinliApp) {
            window.location.href = appUrl
          } else {
            this.$router.push({
              path: h5Router,
              query: {
                id: liveId,
                type,
                token: this.token,
                collectionId
              }
            })
          }
        }
      },
      /*开屏动效*/
      openAnimate() {
        /*动效出现禁止滚动*/
        document.querySelector('.live-container').setAttribute('class', 'live-container hidden-con')

        let gif11 = document.querySelector('.gif-1-1')
        let gif12 = document.querySelector('.gif-1-2')
        let gif13 = document.querySelector('.gif-1-3')
        let gif14 = document.querySelector('.gif-1-4')
        let openCon = document.querySelector('.open-con')
        let openBg = document.querySelector('.open-bg')
        let writeBg = document.querySelector('.write-bg')

        /*gif动画交替出现*/
        const timout1 = setTimeout(() => {
          gif11.setAttribute('style', 'opacity:0')
          gif12.setAttribute('style', 'opacity:1')
          clearTimeout(timout1)
        }, 1000)
        const timout2 = setTimeout(() => {
          gif12.setAttribute('style', 'opacity:0')
          gif13.setAttribute('style', 'opacity:1')
          clearTimeout(timout2)
        }, 1300)
        const timout3 = setTimeout(() => {
          gif13.setAttribute('style', 'opacity:0')
          gif14.setAttribute('style', 'opacity:1')
          clearTimeout(timout3)
        }, 1600)

        /*蒙版放大*/
        const timout4 = setTimeout(() => {
          openBg.setAttribute('class', 'open-bg open-animate')
          writeBg.setAttribute('class', 'write-bg write-animate')
          clearTimeout(timout4)
        }, 1900)

        /*蒙版消失*/
        const timout5 = setTimeout(() => {
          /*开屏动效结束恢复滚动*/
          const containerClassName = this.hideAnimateDom ? 'live-container hide-animate': 'live-container'
          document.querySelector('.live-container').setAttribute('class', containerClassName)

          openCon.setAttribute('style', 'display: none')

          this.hideAnimate()

          if (!this.hideAnimateDom) {
            this.scrollToList()
          }
          /*app执行滚动特效，微信网页端直接跳过*/
          // let { isYixinliApp } = getPlatform()
          // if (isYixinliApp) {
          //   /*开屏动效结束，开始滚动动效*/
          //   this.requestFrame(this.scrollAnimate)
          // } else {
          //   this.scrollToList()
          // }

          clearTimeout(timout5)
        }, 2000)
      },
      /*隐藏动效元素*/
      hideAnimate() {
        if (this.hideAnimateDom) {
          document.querySelector('.bg-con').style.display = 'none'
        }
      },
      /*滚动动效*/
      scrollAnimate() {
        let scrollCon = this.$refs.scrollCon
        if (!scrollCon) {
          return
        }
        let offsetTop = this.getElementTop(this.$refs.scrollCon)
        let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
        let scrollHeight = document.body.scrollHeight - document.documentElement.scrollHeight > 0 ? document.body.scrollHeight : document.documentElement.scrollHeight
        if (!this.isTouch) {
          window.scrollTo(0, scrollTop + 3.5);
        }
        // 防止数据过少，requestFrame一直循环，当滚动到底部的时候return，注意+1是防止document.body.scrollTop为小数导致计算结果错误
        if (scrollTop + document.documentElement.clientHeight + 1 >= scrollHeight) {
          return false
        }
        if (scrollTop < offsetTop - 2) {
          this.requestFrame(this.scrollAnimate)
        }
      },
      /*直达列表*/
      scrollToList() {
        /*定时器防止dom未加载完毕*/
        const scrollInterval = setInterval(() => {
          let offsetTop = this.getElementTop(this.$refs.scrollCon)
          console.log('无滚动动效，直达列表数据', offsetTop)
          if (offsetTop > 0) {
            window.scrollTo(0, offsetTop);
            clearInterval(scrollInterval)
          }
        })
      },
      getElementTop(element) {
        if (!element) {
          return
        }
        // 列表距离顶部距离
        let actualTop = element.offsetTop
        let current = element.offsetParent
        while (current !== null) {
          actualTop += current.offsetTop
          current = current.offsetParent
        }
        return actualTop
      },
      requestFrame(cb) {
        return (
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          function(callback) {
            window.setTimeout(callback, 1000 / 60);
          }
        )(cb);
      },
      handleAppActive() {
        const _this = this
        let methodsList = [
          {
            method: 'appBecomeActiveStatus',
            callback(obj) {
              if (obj.data.status === 'h5Appear') {
                if (_this.loading) return false // ios首次进入页面就会触发appBecomeActiveStatus，安卓则不会，这里做兼容防止重复调init方法
                _this.h5Appear = true // 标记是从上一个页面返回来的
                _this.finish = false
                let pageSize = 10
                if (_this.lastLoadPage > 1) { // 如果有记录最后加载页数，则一次性加载
                  pageSize = _this.lastLoadPage * _this.pageSize
                }
                _this.pageNo = 1
                _this.init(pageSize)
              }
            }
          },
          {
            method: 'topFuncBtn',
            callback: function(ops) {
              if (typeof ops === 'string') ops = JSON.parse(ops)
              let share_config = {
                title: '你喜欢的咨询师主播即将开播，快来预约！',
                desc: '壹心理哆啦dola，好玩有趣',
                link: window.$liveApi.liveList_url,
                imgUrl: 'https://ossimg.xinli001.com/20200702/140056ec4eef46c7577774477dd4c60f.jpg'
              }
              if (ops.name === 'shareReportBtn') {
                bridge.call('shareReport', share_config)
              }
            }
          }
        ]

        let bridge = new Bridge({
          methods: methodsList
        })

        bridge.call('topFuncBtnConfig', {
          btnList: [
            {
              name: 'shareReportBtn',
              visible: 1,
            }
          ]
        })

        /*注册app开屏动画方法*/
        // window.handleAppLiveAnimate = (obj) => {
        //   this.handleAppLiveAnimate(obj)
        // }
        // myBridge.call('isShowLiveListAnimation', { callbackName: 'handleAppLiveAnimate' })
      },
      handleScrollAnimate() {
        let { isYixinliApp, yixinliAPPVersion } = getPlatform()
        if (isYixinliApp && yixinliAPPVersion) {
          let animateVersion = getStorage('liveAnimateVersion')
          console.log('最后动效版本：', animateVersion)
          if (animateVersion && animateVersion === yixinliAPPVersion) { // 记录最后执行过动效的版本
            if (!this.hideAnimateDom) {
              this.scrollToList()
            } else {
              this.hideAnimate()
              const containerClassName = 'live-container hide-animate'
              document.querySelector('.live-container').setAttribute('class', containerClassName)
            }
          } else {
            this.hasOpenAnimate = true
            this.openAnimate()
            setStorage('liveAnimateVersion', yixinliAPPVersion)
          }
        } else {
          this.hasOpenAnimate = true
          this.openAnimate()
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .bg-con {
    position: relative;

    .dola-bg {
      margin-bottom: -26px;
    }

    .gif-1-1,
    .gif-1-2,
    .gif-1-3,
    .gif-1-4 {
      position: absolute;
      top: 304px;
      left: 332px;
      width: 186px;
      z-index: 101;
    }

    .gif-2 {
      position: absolute;
      top: 565px;
      left: -30px;
      width: 381px;
    }

    .gif-3 {
      position: absolute;
      top: 1371px;
      right: 40px;
      width: 200px;
    }

    .gif-4 {
      position: absolute;
      top: 1786px;
      left: 109px;
      width: 229px;
    }

    .gif-5 {
      position: absolute;
      top: 2273px;
      right: 94px;
      width: 206px;
    }

    .gif-6 {
      position: absolute;
      top: 2600px;
      left: 81px;
      width: 303px;
    }

    .gif-7 {
      position: absolute;
      top: 496px;
      right: 30px;
      width: 106px;
      transform: rotateY(180deg);
    }

    .gif-8 {
      position: absolute;
      top: 1419px;
      left: 165px;
      width: 106px;
    }

    .clouds-1 {
      position: absolute;
      top: 80px;
      width: 155px;

      animation: clound1Animate 4s linear infinite;
    }

    @keyframes clound1Animate {
      0% {
        left: 100px;
      }
      50% {
        left: 270px;
      }
      100% {
        left: 100px;
      }
    }

    .clouds-2 {
      position: absolute;
      top: 950px;
      width: 207px;

      animation: clound2Animate 4s linear infinite;
    }

    @keyframes clound2Animate {
      0% {
        left: 220px;
      }
      50% {
        left: 50px;
      }
      100% {
        left: 220px;
      }
    }

    .clouds-3 {
      position: absolute;
      top: 1568px;
      width: 207px;

      animation: clound3Animate 4s linear infinite;
    }

    @keyframes clound3Animate {
      0% {
        left: -48px;
      }
      50% {
        left: 122px;
      }
      100% {
        left: -48px;
      }
    }

    .clouds-4 {
      position: absolute;
      top: 2530px;
      width: 155px;

      animation: clound4Animate 4s linear infinite;
    }

    @keyframes clound4Animate {
      0% {
        left: 316px;
      }
      50% {
        left: 486px;
      }
      100% {
        left: 316px;
      }
    }
  }

  .open-con {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    display: flex;
    justify-content: flex-start;;
    align-items: center;
    flex-direction: column;
    background: #fff;

    .write-bg {
      position: absolute;
      bottom: 0;
      margin-bottom: -50%;
      width: 100%;
      background-color: #fff;
      height: calc(100vh - 370px);
      -webkit-transform-origin:left bottom;
      transform-origin:left bottom;
      transition:all .5s ease;
    }

    .write-animate {
      transform: scaleY(.8);
    }

    .open-bg {
      -webkit-transform-origin:center center;
      transform-origin:center center;
      transition:all .5s ease;
    }

    .open-animate {
      transform: scale(3);
    }
  }

  .hidden-con {
    overflow: hidden;
    height: 100vh;
  }

  .live-container {
    min-height: 100vh;

    background-color: #5457DA;
    &.hide-animate {
      background-color: #FFF;
      .scroll-con {
        margin-top: 0;
        padding-top: 30px;
      }
      .load-state {
        color: #333;
      }
      .no-list {
        p {
          color: #333;
        }
      }
    }
  }

  .scroll-con {
    position: relative;
    overflow: auto;
    padding-top: 110px;
    margin-top: -130px;
    min-height: calc(100vh - 110px);

    .load-state {
      width: 100%;
      padding: 30px 0;
      text-align: center;
      line-height: 30px;
      color: #fff;
    }
  }

  .live-container {
    position: relative;

    .replay-btn {
      position: absolute;
      top: 2880px;
      right: 30px;
      width: 200px;
      height: 72px;
      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 28px;
      border-radius: 36px;
      background: rgba(0, 0, 0, .3);
      color: #fff;
      z-index: 101;

      .svg-icon {
        margin-bottom: -4px;
        font-size: 20px;
      }
    }

    .live-top-con {
      width: 100%;
      padding: 100px 0;
      font-size: 80px;
      color: #FFF;
      text-align: center;
    }
  }

  .preview-list-con {
    max-width: 750px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 30px;
  }

  .living-item-container {
    margin: 0 auto;
    margin-bottom: 30px;
    height: 388px;
    width: 690px;

    border-radius: 10px;
    overflow: hidden;

    &.isBilling {
      height: 270px;
    }
  }

  .live-item-container {
    max-width: 48%;
    width: 330px;
    height: 482px;
    margin: 0 0 30px 0;

    border-radius: 10px;
    overflow: hidden;
  }

  .no-list {
    min-height: calc(100vh - 100px);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    img {
      width: 330px;
    }

    p {
      margin-top: 30px;
      font-size: 28px;
      color: #fff;
      text-align: center;
    }
  }
</style>
